import { connect } from 'react-redux';
import Footer from '../components/footer/Footer';
import {
  breakfastType,
  dinnerType,
  entertainmentType,
  breakfastPage,
  dinnerPage,
  entertainmentPage,
  entertainmentDetailsPage,
  swimmingDetailsPage,
  getIsAllowedToChangeDining,
  isSplash,
  checkIfTravelAgentBooking,
  dineAroundDetailsPage,
  getIfAllowedToBook,
} from '../utils';

const findEntertainmentItem = (entertainments = [], entertainmentItem, eventId) => {
  const newEntertainmentItem = entertainmentItem;
  entertainments.forEach(({ events = [] }) => {
    events.forEach(({ slots = [], code, name }) => {
      slots.forEach(({ Id }) => {
        if (Id === eventId) {
          newEntertainmentItem.id = code;
          newEntertainmentItem.name = name;
        }
      });
    });
  });
  return newEntertainmentItem;
};

const getEntertainmentItem = (entertainments = [], splashEntertainments = [], dineAroundItems = [], id) => {
  const eventId = parseInt(id, 10);
  let entertainmentItem = {
    id: 0,
    name: '',
  };

  entertainmentItem = findEntertainmentItem(entertainments, entertainmentItem, eventId);

  if (entertainmentItem.id === 0) {
    entertainmentItem = findEntertainmentItem(splashEntertainments, entertainmentItem, eventId);
  }

  if (entertainmentItem.id === 0) {
    entertainmentItem = findEntertainmentItem(dineAroundItems, entertainmentItem, eventId);
  }

  return entertainmentItem;
};

const getRedirectPath = ({ events = [] }, { entertainments, splashEntertainments, dineAroundItems }, eventId, redirectPath) => {
  const event = events.find(({ id }) => id === eventId);
  if (!event) return redirectPath;
  const { type, isDineAroundItem } = event;
  if (type === breakfastType) return breakfastPage;
  if (type === dinnerType) return dinnerPage;
  const entertainmentItem = getEntertainmentItem(entertainments, splashEntertainments, dineAroundItems, eventId);
  if (isDineAroundItem) return `${dineAroundDetailsPage}&entertainmentId=${entertainmentItem.id}`;
  if (entertainmentItem.id && isSplash(entertainmentItem.name)) return `${swimmingDetailsPage}&entertainmentId=${entertainmentItem.id}`;
  return !entertainmentItem.id ? entertainmentPage : `${entertainmentDetailsPage}&entertainmentId=${entertainmentItem.id}`;
};

const getShowLink = ({ events = [] }, dinings, bookingSearch, eventId, config) => {
  const event = events.find(({ id }) => id === eventId);
  if (!event) return true;
  const { type, name, isDineAroundItem } = event;
  if (type === breakfastType || type === dinnerType) return getIsAllowedToChangeDining(dinings, bookingSearch, type);
  if (type === entertainmentType) {
    const { isAllowedToBookSwimming, isAllowedToBookEntertainment, isAllowedToBookDineAround } = getIfAllowedToBook(bookingSearch, config);
    if (isSplash(name)) return isAllowedToBookSwimming;
    if (isDineAroundItem) return isAllowedToBookDineAround;
    return isAllowedToBookEntertainment;
  }
  return true;
};

const getAtLeastOneBookedSplash = (bookedEntertainments) => {
  let isSplashBooking = false;
  if (!bookedEntertainments || bookedEntertainments.length === 0) {
    return isSplashBooking;
  }
  bookedEntertainments.forEach(({ ActivityName: name }) => {
    if (isSplash(name)) {
      isSplashBooking = true;
    }
  });
  return isSplashBooking;
};

const getTypeOfButton = (buttonType, isEntertainmentListPage, { entertainments }, isSwimmingPage, { maxAllowedPoolSlots }) => {
  if (isEntertainmentListPage && entertainments.length > 0) return 'done';
  if (isSwimmingPage && maxAllowedPoolSlots > 1 && getAtLeastOneBookedSplash(entertainments)) return 'next';
  return buttonType;
};

const mapStateToProps = ({
  bookedEvents,
  bookedEntertainments,
  availableEntertainments,
  dinings,
  bookingSearch,
  config,
}, {
  showIndicators,
  activeIndicator,
  numberOfIndicators,
  buttonType,
  redirectPath,
  eventId,
  isEntertainmentListPage,
  isSwimmingPage,
}) => ({
  showIndicators,
  activeIndicator,
  numberOfIndicators,
  buttonType: getTypeOfButton(buttonType, isEntertainmentListPage, bookedEntertainments, isSwimmingPage, bookingSearch),
  redirectPath: getRedirectPath(bookedEvents, availableEntertainments, eventId, redirectPath),
  showLink: getShowLink(bookedEvents, dinings, bookingSearch, eventId, config),
  isTravelAgentBooking: checkIfTravelAgentBooking(bookingSearch.agencyType),
});

export default connect(mapStateToProps)(Footer);
